export enum PreregistrationFilterEnum {
    ALL = 'all',
    WAITING = 'waiting',
    TO_SEND = 'to_send',
    TO_FOLLOW_UP = 'to_follow_up',
    CONFIRMED = 'confirmed',
    EXPIRED = 'expired',
}
